import { useQuery } from '@apollo/client';
import {
  LmsCertificate,
  LmsCertificateListFilterInput,
  LmsCertificatesDocument,
  LmsCertificateSortingInput,
} from 'src/graphql/generated/graphql';

interface UseCertificatesProps {
  filter?: LmsCertificateListFilterInput;
  sorting?: LmsCertificateSortingInput;
  pagination?: {
    limit: number;
    page: number;
  };
  skip?: boolean;
}

export const useCertificates = (props?: UseCertificatesProps) => {
  const { filter, pagination, sorting, skip } = props || {};
  const { limit = 300, page = 0 } = pagination || {};
  const offset = page * limit;

  const { data, loading } = useQuery(LmsCertificatesDocument, {
    variables: {
      filter,
      sorting,
      pagination: {
        limit,
        offset,
      },
    },
    skip,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
  });

  return {
    certificates: (data?.lmsCertificates?.records as LmsCertificate[]) || [],
    totalCount: data?.lmsCertificates?.pagination?.totalCount || 0,
    loading,
  };
};
